import React from 'react'
import './mentors.css'
import Modal from "../../components/Modal"
import "animate.css/animate.min.css"
import PropTypes from "prop-types"
import Link from "gatsby-link"
import ContentPage from "../../components/content-page"
import Meta from "../../components/meta"
import mentors_constants1 from '../../constant/mentors3'
import KnowledgeCenter from "../../components/knowledgeCenter"

const TeamModal = ({ activeItem, show, onHide }) => {
	return (
		<Modal direction="" className="teamdetails__wrapper" show={show} onHide={onHide}>
			<Modal.Header>
				<div className="head_section">
					<span className="item_name">{activeItem.name}</span>
					<div className="item_des">{activeItem.post}</div>
					<div className="item_des">{activeItem.cmp}</div>
				 
				</div>
				<span className="cross pull-right">
					<i onClick={onHide} className="fa fa-times" />
				</span>
			</Modal.Header>
			<Modal.Body>
				<div className="item__desc">
					<div className="item__desc_scr" style={{ padding:"0px 10px 0px 0px"}} dangerouslySetInnerHTML={{ __html: activeItem.desc }}></div>
				</div>
			</Modal.Body>
			<Modal.Footer />
		</Modal>
	)
}

TeamModal.propTypes = {
	activeItem: PropTypes.object,
	show: PropTypes.object,
	onHide: PropTypes.object,
}
export class Mentors extends React.Component{
    constructor (args) {
		super(args)
		this.state = {
			activeItem: {},
			isShow: false
		}
	}
	togglePopUp = (item) => {
		this.setState({
			isShow: !this.state.isShow,
			activeItem: item || {}
		})
	}

    render(){
    	const { location } = this.props
        const { isShow } = this.state
        return(
        	<ContentPage>
        		<Meta title="Winpe ProClub Mentorship Program | Mentors" description="Our mentors include eminent industry leaders who have had a rich professional and leadership journey and who are now keen to support the growth of female talent into future leaders." image={"https://winpeforum.com/assets/elements/winpe_proclub_updated_linkimage1.jpg"} location={location} />
	            <div className="mentors-wrapper">
	                <section id="team" className="pb-5">
						<div className="container">
							<h1 className="section-title h1">Mentors<br/>Cohort IV</h1>
							<div className="section_intro_text">Our mentors include eminent industry leaders who have had a rich professional and leadership journey and who are now keen to support the growth of female talent into future leaders.</div>
							<div className="row">
								{mentors_constants1.map((item, i) => {
									return (
							            <div className="col-xs-12 col-sm-6 col-md-4">
							                <div className="" >
							                    <div className="mainflip flip-0" style={{minHeight:'450px'}}>
							                        <div className="frontside">
							                            <div className="card">
							                                <div className="card-body text-center mt-4">
							                                    <p><img onClick={() => this.togglePopUp(item)} className=" img-fluid" src={item.imgUrl} alt={item.name} /></p>
							                                    <div className="car_title">{item.name}</div>
							                                    <div className="car_text1">{item.post}</div>
							                                    <div className="car_text1">{item.cmp}</div>
																<div className="car_text" style={{height:'auto'}}>{item.cohort}</div>
							                                    <a target="_blank" href={item.link} className="btn btn-primary btn-sm" ><i className="fa fa-linkedin"></i></a>
							                                </div>
							                            </div>
							                        </div>   
							                    </div>
							                </div>
							            </div>
	            					)
								})}
	            			 <div className="col-xs-12 col-sm-6 col-md-4">
							                <div className="" >
							                    <div className="mainflip flip-0">
							                        <div className="frontside">
							                            <div className="card">
							                                <div className="card-body text-center mt-4">
							                                     &nbsp;
							                                </div>
							                            </div>
							                        </div>   
							                    </div>
							                </div>
							            </div></div>
	            		</div>
	            		<TeamModal show={isShow} onHide={this.togglePopUp} activeItem={this.state.activeItem} />
	            	</section>
	            </div>
	        </ContentPage>
        )
    }
}
Mentors.propTypes = {
	location: PropTypes.object
}

export default Mentors



// WEBPACK FOOTER //
// ./src/pages/cohortIV-mentors/index.jsx